import React from "react";
import "../Css/HomeBannerNew.css";
import banner from "../Assets/banner-sejal.mp4";
import { getProfile } from "../services/localStorageServices";
import bgImage from "../Assets/LoginBackground.jpg";
import { useSelector } from "react-redux";

const HomeBannerNew = () => {
  const { profile } = getProfile();

  return (
    <div
      className="homeSection"
      id="home"
      style={
        profile.verify =="1"
          ? {}
          : { backgroundImage: "url(" + bgImage + ")" }
      }
    >
      {profile.verify =="1" && (
        <video className="controls" playsInline autoPlay muted loop>
          <source src={banner} type="video/mp4" />
        </video>
      )}
    </div>
  );
};

export default HomeBannerNew;
